export default __webpack_public_path__ + "static/media/share-button.2f63af0f.svg";